import "./pagenotfound.scss";
// import { Button } from "antd";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { setFlagAuthVal, setLookup } from "../../redux/reducer/auth";

export default function PageNotFound() {
  // let navigate = useNavigate();
  // let dispatch = useDispatch();

  // const backToLogin = () => {
  //   navigate("/", { replace: true });
  //   dispatch(setFlagAuthVal(false));
  //   dispatch(setLookup([]));
  // };

  return (
    <div id="page_not_found">
      <div className="pnf_code">404</div>
      <div className="pnf_title">Page Not Found</div>
      <div className="pnf_text">
        The page you are looking for is not available.
      </div>
      {/* <Button className="pnf_button" onClick={backToLogin}>
        Back to Login
      </Button> */}
    </div>
  );
}
